/**
 * labels — UM nome por conceito, escrito de UM jeito só.
 *
 * Por que existe: o mesmo módulo aparecia com três grafias diferentes na mesma
 * sessão de uso, e isso foi MEDIDO no texto renderizado do aparelho, não deduzido
 * do código:
 *
 *   | conceito          | home              | menu "+"          | página          |
 *   |-------------------|-------------------|-------------------|-----------------|
 *   | ordem de serviço  | Ordens de Serviço | Ordem de serviço  | Ordens de serviço |
 *   | venda rápida      | Venda Rápida      | Venda rápida      | Venda Rápida    |
 *   | nota fiscal       | Nota Fiscal       | Nota fiscal       | NFS-e           |
 *
 * Para quem construiu o app são variações triviais. Para quem está aprendendo a
 * usá-lo, "Nota Fiscal" e "NFS-e" podem ser duas coisas — e é ele que decide a
 * nota na loja.
 *
 * REGRA DE GRAFIA: **sentence case** (só a primeira letra maiúscula), como o
 * resto do português. Title Case é importado do inglês e, aplicado a metade dos
 * rótulos, produz exatamente a inconsistência da tabela acima.
 *
 * SIGLA NUNCA SOZINHA num título. "NFS-e" é o nome técnico do documento; o nome
 * que o prestador conhece é "nota fiscal". A sigla entra como apoio (subtítulo,
 * parêntese), nunca como a única palavra na tela.
 *
 * O guard de varredura em `src/test/labels.test.ts` proíbe as grafias erradas
 * voltarem — é ele que impede a mesa de novo, porque nada mais no app reclama
 * quando alguém escreve "Venda Rápida" à mão.
 */

export const MODULE_LABELS = {
  quote: { one: 'Orçamento', many: 'Orçamentos' },
  /** `short` é para onde o espaço é medido em pixels (trilha, eixo de gráfico). */
  serviceOrder: { one: 'Ordem de serviço', many: 'Ordens de serviço', short: 'OS' },
  quickSale: { one: 'Venda rápida', many: 'Vendas rápidas' },
  invoice: { one: 'Nota fiscal', many: 'Notas fiscais', acronym: 'NFS-e' },
  contract: { one: 'Contrato', many: 'Contratos' },
  receipt: { one: 'Recibo', many: 'Recibos' },
  client: { one: 'Cliente', many: 'Clientes' },
  appointment: { one: 'Compromisso', many: 'Compromissos' },
  financeEntry: { one: 'Lançamento', many: 'Lançamentos' },
} as const;

/**
 * Grafias PROIBIDAS → a certa. Consumido pelo guard; fica aqui para a regra e a
 * proibição não morarem em arquivos diferentes.
 */
export const FORBIDDEN_LABEL_SPELLINGS: ReadonlyArray<readonly [string, string]> = [
  ['Ordens de Serviço', MODULE_LABELS.serviceOrder.many],
  ['Ordem de Serviço', MODULE_LABELS.serviceOrder.one],
  ['Venda Rápida', MODULE_LABELS.quickSale.one],
  ['Vendas Rápidas', MODULE_LABELS.quickSale.many],
  ['Nota Fiscal', MODULE_LABELS.invoice.one],
  ['Notas Fiscais', MODULE_LABELS.invoice.many],
];
